import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';

const sdo = {
  namespace: sdoNs.LICENSE_ASSIGN,
  mutations: {

    /**
     * @return {Object}
     */
    init() {
      return {};
    },

    setData(substate, data) {
      return data;
    },
  },
  decorators: [],
};

storeInstance.addState(sdo);
